export class CertificationExam {
  /**
   * @param {string} id - 자격증 시험 아이디
   * @param {string} name - 시험 이름
   * @param {string} level - 자격증 레벨
   * @param {Date} startAt - 시작 일시
   * @param {Date} finishAt - 시작 일시
   * @param {number} examTime - 시험 시간
   * @param {number} questionCount - 문항수
   * @param {string} state - 상태
   */
  constructor({ id, name, level, startAt, finishAt, examTime, questionCount, state }) {
    this.id = id
    this.name = name
    this.level = level
    this.startAt = startAt
    this.finishAt = finishAt
    this.examTime = examTime
    this.questionCount = questionCount
    this.state = state
  }
}
